import React, { useContext } from 'react';

import { useLocation } from 'react-router';
import AnalyticsContext from '../../../context/AnalyticsContext';
import { useImageUpload } from '../ImageUploadContext/ImageUploadContext';

const CustomUploadButton = ({ children }: { children: React.ReactElement }) => {
  const { handleFileInputClick } = useImageUpload();
  const analytics = useContext(AnalyticsContext);
  const location = useLocation();
  const isEdit = location.pathname.toLowerCase().includes('edit');
  const handleButtonClick = (event: MouseEvent) => {
    event.preventDefault();
    analytics.trackEvent(
      isEdit ? 'new-pet-profile-edit' : 'new-pet-profile',
      'personalized_avatar',
      'Start',
    );
    handleFileInputClick();
  };
  // Here, we're cloning our child and attaching an onClick wired up to our context.
  // This allows us to pass in any child visually while still being able to use cleanly with the image upload context.
  // Note, since this is an interactive element, you should probably use a button child
  return React.cloneElement(children, { onClick: handleButtonClick });
};

export default CustomUploadButton;
